import { render, staticRenderFns } from "./ImprimirButton.vue?vue&type=template&id=ed7698ba&scoped=true&"
import script from "./ImprimirButton.vue?vue&type=script&lang=ts&"
export * from "./ImprimirButton.vue?vue&type=script&lang=ts&"
import style0 from "./ImprimirButton.vue?vue&type=style&index=0&id=ed7698ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed7698ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('ed7698ba', component.options)
    } else {
      api.reload('ed7698ba', component.options)
    }
    module.hot.accept("./ImprimirButton.vue?vue&type=template&id=ed7698ba&scoped=true&", function () {
      api.rerender('ed7698ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Facturacion/ImprimirButton.vue"
export default component.exports